<template>
    <div :class="'bizcomp-acct-manager bizcomp ' + className">
        <div class="acct-manager-head">
            <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#ffffff"
                text-color="#666666"
                active-text-color="var(--color-primary)"
                v-on:select="handleSelect"
            >
                <el-menu-item index="1">
                    <div :class="'height-63 ' + (activeIndex == '1' ? 'border-4' : '')">
                        账户信息
                    </div>
                </el-menu-item>
                <el-menu-item index="2">
                    <div :class="'height-63 ' + (activeIndex == '2' ? 'border-4' : '')">
                        账户安全
                    </div>
                </el-menu-item>
                <el-menu-item v-if="serviceBookingDisplay" index="3">
                    <div :class="'height-63 ' + (activeIndex == '3' ? 'border-4' : '')">
                        服务订阅
                    </div>
                </el-menu-item>
                <el-submenu v-if="$util.getFundClass() == '1'" index="6" style="width: 180px">
                    <template slot="title">
                        <div class="submenu-title" style="display: flex; align-items: center">
                            协议/合同列表
                            <i
                                :class="
                                    'el-icon-arrow-down own-icon-arrow-down ' +
                                    (activeIndex.length === 3 ? 'color-e60012' : '')
                                "
                            ></i>
                        </div>
                    </template>
                    <div class="el-menu-group">
                        <el-menu-item index="6-1">协议列表</el-menu-item>
                        <el-menu-item index="6-2">电子合同列表</el-menu-item>
                    </div>
                </el-submenu>
                <el-menu-item
                    v-if="$util.getConfig().hideFunc && !$util.isWebQueryMode()"
                    index="5"
                >
                    <div :class="'height-63 ' + (activeIndex == '5' ? 'border-4' : '')">
                        注销账户
                    </div>
                </el-menu-item>
            </el-menu>
        </div>
        <div class="bottom-info">
            <acct-info-dc v-if="activeIndex == '1'"></acct-info-dc>
            <acct-security-dc v-if="activeIndex == '2'"></acct-security-dc>
            <service-subscript v-if="activeIndex == '3'"></service-subscript>
            <unsubscribe v-if="activeIndex == '5'"></unsubscribe>
            <agreement-list v-if="activeIndex == '6-1'"></agreement-list>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import AcctInfoDc from "./accInfoDc.vue";
import AcctSecurityDc from "./acctSecurityDc.vue";
import ServiceSubscript from "./serviceSubscript.vue";
import Unsubscribe from "./unsubscribe.vue";
import AgreementList from "./agreementList.vue";

const LEGACY_BANK_ROUTE_MAP = {
    "4-1": { name: "bankmanager" },
    "4-2": { name: "bankmanager", query: { activeIndex: "2" } },
    "4-3": { name: "bankmanager", query: { activeIndex: "3" } },
    "4-4": { name: "bankmanager", query: { activeIndex: "4" } }
};

export default {
    name: "AcctManager",
    components: {
        AcctInfoDc,
        AcctSecurityDc,
        ServiceSubscript,
        Unsubscribe,
        AgreementList
    },
    mixins: [mixin],
    data() {
        return {
            activeIndex: "1",
            serviceBookingDisplay: false
        };
    },
    watch: {
        "$route.query.activeIndex"() {
            this.syncActiveIndex();
        }
    },
    mounted() {
        this.syncActiveIndex();
        this.serviceBookingDisplay =
            this.$cache.getParamValue("customized_server") &&
            this.$cache.getParamValue("customized_server").customized_server &&
            this.$cache.getParamValue("customized_server").customized_server.length > 0;
    },
    methods: {
        syncActiveIndex() {
            const routeActiveIndex = this.$route.query.activeIndex || "1";
            if (
                this.$util.isWebQueryMode() &&
                (routeActiveIndex.indexOf("4") === 0 || routeActiveIndex === "5")
            ) {
                this.activeIndex = "1";
                this.$route.query.activeIndex = this.activeIndex;
                return;
            }
            if (this.redirectLegacyBankRoute(routeActiveIndex)) {
                return;
            }
            this.activeIndex = routeActiveIndex;
            this.$route.query.activeIndex = this.activeIndex;
        },
        redirectLegacyBankRoute(activeIndex) {
            const legacyRoute = LEGACY_BANK_ROUTE_MAP[activeIndex];
            if (!legacyRoute) {
                return false;
            }
            this.$router.replace(legacyRoute);
            return true;
        },
        handleSelect(key) {
            this.activeIndex = key;
            if (key == "6-2") {
                this.$router.push({
                    name: "contract"
                });
            } else {
                this.$router.push({
                    path: this.$route.path,
                    query: { activeIndex: this.activeIndex }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.el-menu-group {
    display: flex;
    position: relative;
    left: 10px;
    padding-right: 20px;
    .el-menu-item {
        background-color: rgba(255, 255, 255, 0) !important;
    }
    :deep(.el-menu-item:hover) {
        color: var(--color-primary) !important;
        background-color: rgba(255, 255, 255, 0) !important;
    }
}

.bizcomp-acct-manager {
    .acct-manager-head {
        height: 70px;
        padding-bottom: 7px;
        border: 1px solid #f1f1f1;
        box-sizing: border-box;
        width: 1198px;
    }

    :deep(.el-menu) {
        border: none;
    }

    :deep(.is-active) {
        color: var(--color-primary) !important;
        .el-submenu__title {
            border: none;
        }
        .submenu-title {
            border-bottom: 4px solid var(--color-primary) !important;
            .el-icon-arrow-down {
                margin: 0;
                text-align: right;
            }
        }
    }

    :deep(.el-submenu__title:hover) {
        color: var(--color-primary) !important;
        .own-icon-arrow-down {
            color: var(--color-primary) !important;
        }
    }
    :deep(.isopened) {
        color: #cccccc !important;
    }
    :deep(.el-submenu__icon-arrow) {
        color: #ffffff !important;
    }
    :deep(.el-submenu__title) {
        display: flex;
        align-items: center;
    }
    :deep(.el-submenu) {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 59px;
        line-height: 59px;
        border: none;
    }
    :deep(.el-submenu__title) {
        background-color: #ffffff !important;
        font-size: 20px !important;
        color: #666;
    }
    .el-menu-item {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 59px;
        line-height: 59px;
        font-size: 20px;
        color: #666;
        border: none;
        background-color: #ffffff !important;
    }
    .el-menu-item:hover {
        color: var(--color-primary) !important;
        background-color: #ffffff !important;
    }
    :deep(.is-active) {
        color: var(--color-primary);
        font-weight: 500;
    }
    .color-e60012 {
        color: var(--color-primary);
    }
    .border-4 {
        border-bottom: 4px solid var(--color-primary);
    }
    .height-63 {
        width: 80px;
        height: 59px;
        margin: auto;
    }
    .bottom-info {
        padding: 21px 16px 20px 20px;
        width: 1198px;
        box-sizing: border-box;
    }
}
</style>
